import React from "react";
import {openPopupWindow, openV1PopupInfo} from "../../../../../../emitters/popup";
import {CURRENCY_ITEMS, STABLECOINS} from "../../../../../../constants";
import Select from "../../../../../dumb/Select/B";
import Popup from "../../../../../dumb/Popup/C";
import Switch from "../../../../../dumb/Switch/D";
import {apiAdminPayoutVertoUpdate} from "../../../../../../api/admin/payout/verto";
import WrapperWithLoading from "../../../../../dumb/WrapperWithLoading";
import TextField from "../../../../../dumb/TextField/H";

export const openPopupSend = (data, update) => openPopupWindow((setPopupState, popup) => {
  const close = popup.close;
  const handleChange = (name) => (e) => setPopupState({[name]: e instanceof Object ? e.target.value : e});

  popup.state = {
    ...popup.state,
    amount: data.amount || '',
    fiatCode: data.fiat_code || CURRENCY_ITEMS[0].id,
    comment: '',
    editEnabled: !!data.editMode
  }

  return (state) => {
    const id = data.id;

    const clicked = state.clicked;
    const loading = state.loading;

    const editEnabled = state.editEnabled;
    const amount = state.amount;

    const amountRequired = !amount;
    const amountIsNaN = isNaN(amount);
    const amountAboveZero = Number(amount) <= 0;

    const amountHelperText = amountIsNaN
      ? 'Must be a number'
      : amountAboveZero
        ? 'Must be above zero'
        : '';

    const amountHasError = amountRequired || amountIsNaN || amountAboveZero;

    const fiatCode = state.fiatCode;
    const comment = state.comment;

    const fieldsDisabled = !editEnabled;

    const fields = [
      {
        label: 'ID',
        value: data.id,
        disabled: true
      },
      {
        label: 'Original amount *',
        value: data.amount,
        disabled: true
      },
      {
        component: Select,
        label: 'Original currency *',
        propName: 'id',
        propValue: 'id',
        items: [...CURRENCY_ITEMS, ...STABLECOINS],
        value: data.fiat_code,
        disabled: true
      },
      {
        label: 'Settlement amount *',
        value: amount,
        onChange: handleChange('amount'),
        error: amountHasError,
        helperText: amountHelperText,
        disabled: fieldsDisabled || loading
      },
      {
        component: Select,
        label: 'Settlement currency *',
        propName: 'id',
        propValue: 'id',
        items: [...CURRENCY_ITEMS, ...STABLECOINS],
        value: fiatCode,
        onChange: handleChange('fiatCode'),
        disabled: fieldsDisabled || loading
      },
      {
        label: 'Payout details',
        value: comment,
        onChange: handleChange('comment'),
        disabled: fieldsDisabled || loading
      }
    ];

    const disabled = amountHasError;

    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Send Payout</div>
            {!data.editMode && (
              <>
                <div className="mh30 fw3 rlv st-2">|</div>
                <Switch
                  label="Enable Editing"
                  checked={editEnabled}
                  onChange={() => setPopupState({editEnabled: !editEnabled})}
                />
              </>
            )}
          </div>
        )}
        disabled={clicked && disabled}
        onCancel={close}
        text="Send"
        onSave={() => {
          setPopupState({clicked: true});

          if (disabled) return;

          setPopupState({loading: true});

          const params = editEnabled
            ? {
              withdraw_id: id,
              converted_amount: amount,
              converted_fiat_code: fiatCode,
              admin_comment: comment
            } : {
              withdraw_id: id,
            }

          return apiAdminPayoutVertoUpdate(params)
              .then(update)
              .then(close)
              .then(() => openV1PopupInfo([`Payout ${id} completed.`]))
              .finally(() => setPopupState({loading: false}));

          // setPopupState({loading: true});
        }}
      >
        <WrapperWithLoading
          loading={state.loading}
        >
          <div className="wmax910">
            {editEnabled
              ? fields.map(({component: C = TextField, className, error, ...rest}, i) => (
                <C
                  key={i}
                  className={`mt20 wmax472` + (className ? ` ${className}` : '')}
                  {...rest}
                  error={clicked && error}
                />
              ))
              : (
                <div className="mt15 lh22">
                  Please, confirm that you want to send <b>{data.amount} {data.fiat_code}</b> to <b>{!data.merchant_email ? data.account_id : data.merchant_email}</b>  without any changes?
                </div>
              )
            }
          </div>
        </WrapperWithLoading>
      </Popup>
    )
  }
})
